<template>
    <div class="changing-cards-container">
        <div class="changing-cards-horizontal-scroller">
            <div class="changing-cards">
                <div
                    v-for="(cardItem, itemIndex) in cardDataList"
                    :key="itemIndex"
                    ref="scroller"
                    class="changing-card-container"
                    :class="{ active: itemIndex === data.currentIndex }"
                    @click="updateIndex(itemIndex)"
                >
                    <slot name="card-item">
                        <CommonComponentsCardTransform
                            :key="itemIndex"
                            :background-image="cardItem.bgImage"
                            class="changing-transform-card"
                            hide-arrow
                        >
                            <template #transform-card-title>
                                <div class="changing-transform-card-title" v-html="$t(cardItem.title)" />
                            </template>
                            <template v-if="cardItem.follow" #transform-card-follow>
                                <div class="changing-transform-card-follow" v-html="$t(cardItem.follow)" />
                            </template>
                            <template v-if="iconed" #transform-card-icon>
                                <Component :is="cardItem.icon" />
                            </template>
                        </CommonComponentsCardTransform>
                    </slot>
                </div>
            </div>
        </div>
        <div class="active-card-des">
            <slot name="card-des">
                <div v-html="$t(cardDataList[data.currentIndex].follow)" />
            </slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { reactive, watch } from 'vue';
    import { gsap } from 'gsap';
    import { ScrollTrigger } from 'gsap/all';
    gsap.registerPlugin(ScrollTrigger);
    withDefaults(
        defineProps<{
            cardDataList: Array<UnionTitle>;
            iconed?: boolean;
        }>(),
        {
            iconed: false,
        },
    );

    const data = reactive({
        currentIndex: 0,
    });

    const emits = defineEmits<{
        (e: 'update:modelValue', index: number): void;
    }>();

    watch(
        () => data.currentIndex,
        (value) => {
            emits('update:modelValue', value);
        },
        { immediate: true },
    );

    const updateIndex = (i: number) => {
        data.currentIndex = i;
    };
</script>

<style lang="less" scoped>
    .changing-cards-container {
        .changing-cards-horizontal-scroller {
            overflow-x: scroll;
            padding: 4px 15px;

            &::-webkit-scrollbar {
                display: none;
                width: 0;
                height: 0;
            }
            .changing-cards {
                display: flex;
                width: fit-content;
                // overflow: hidden;
                // gap: 10px;
                // transition: all 0.2s ease;

                .changing-card-container {
                    flex-shrink: 0;

                    width: .convert(140px) [ @vw-mobile];
                    height: .convert(173px) [ @vw-mobile];
                    font-size: 48px;
                    position: relative;

                    &:not(:last-child) {
                        margin-right: 10px;
                    }

                    &::before {
                        content: '';
                        opacity: 0;
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        padding: 2px;
                        box-sizing: content-box;
                        border-radius: 10px;
                        border: 1px solid #0032ff;
                        transition: all 0.4s ease-in-out;
                    }
                    &.active::before {
                        opacity: 1;
                    }

                    .changing-transform-card {
                        border-radius: 10px;
                        padding: 10px;
                        .changing-transform-card-title,
                        .changing-transform-card-follow {
                            filter: drop-shadow(0 0 1rem #3a3a3a);
                        }
                    }
                }
            }
        }
        .active-card-des {
            margin-top: 15px;
            padding: 0 15px 0 15px;

            transition: all 0.4s ease-in-out;
        }
    }

    :lang(en) {
        .changing-transform-card-title {
            @media (max-width: @screen-mobile-width) {
                font-size: .convert(18px) [ @vh];
            }
        }
    }
</style>
